import { VesselData } from "../vessel-reg/vessel-data.model";
import { LookupItem } from '../shared/lookup-item.model';

/**
 * Represents a distinct user will all identifying information, vessels, and favorite species.
 */
export class OperatorUser {

  //URL for the CouchDB instance to sync data for users
  couchDbConnection: string = '';

  operatorUserID!: number;

  userIdentity: string = '';

  firstName: string = '';

  lastName: string = '';

  userName: string = '';

  email: string = '';

  emailConfirmed: boolean = false;

  licenseNumber: string = '';

  phoneNumber: string = '';

  accessToken: string = '';

  refreshToken: string = '';

  groundfishFishery: boolean = false;

  hmsFishery: boolean = false;

  trawlFishery: boolean = false;

  // user vessel list
  operatedVessels: VesselData[] = [];

  // user species list
  favoriteSpecies: LookupItem[] = [];


  static transformAnonymous(anon: any): OperatorUser {
    let user = new OperatorUser();
    user.couchDbConnection = anon.couchDbConnection ?? '';
    user.userName = anon.userName;
    user.operatorUserID = anon.operatorUserID;
    user.userIdentity = anon.userIdentity
    user.firstName = anon.firstName;
    user.lastName = anon.lastName;
    user.userName = anon.userName;
    user.email = anon.email;
    user.emailConfirmed = anon.emailConfirmed ?? true;
    user.licenseNumber = anon.licenseNumber;
    user.phoneNumber = anon.phoneNumber;
    user.accessToken = anon.accessToken;
    user.refreshToken = anon.refreshToken;
    user.groundfishFishery = anon.groundfishFishery ?? true;
    user.hmsFishery = anon.hmsFishery ?? false;
    user.trawlFishery = anon.trawlFishery ?? false;
    if (!user.groundfishFishery && !user.hmsFishery && !user.trawlFishery) user.groundfishFishery = true;
    user.operatedVessels = anon.operatedVessels ? VesselData.transformAnonymous(anon.operatedVessels) : [];
    user.favoriteSpecies = anon.favoriteSpecies ? LookupItem.transformAnonymousArr(anon.favoriteSpecies) : [];
    return user;
  }

  setupNewUser(json: any) {
    this.operatorUserID = json.apiUserId ?? json.userId;
    this.userIdentity = json.apiUserIdentity ?? json.userIdentity;
    this.firstName = json.firstName;
    this.lastName = json.lastName;
    this.userName = json.userName;
    this.email = json.email;
    this.emailConfirmed = false;
    this.licenseNumber = json.licenseNumber ?? json.properties.licenseNumber;
    this.phoneNumber = json.phone;
    this.accessToken = json.accessToken;
    this.refreshToken = json.refreshToken;
    this.couchDbConnection = json.couchDbConnection ?? '';
  }
}
